export function isAdminApp(slug) {
	return [
		process.env.GOOGLE_SYNC_SLUG,
		process.env.GOOGLE_MATCH_SLUG,
		process.env.SINGLE_SIGN_ON_SLUG,
		process.env.AZURE_AD_SLUG,
		process.env.AD_SLUG,
		process.env.FSM_SLUG,
		process.env.TEST_REGISTER_SLUG,
		process.env.APPLE_SYNC_SLUG,
		process.env.HOLIDAY_ACTIVITIES_SLUG,
		process.env.EDUSYNC_MICROSOFT_SLUG,
	].includes(slug);
}

export function isSingleSignOn(slug) {
	return slug === process.env.SINGLE_SIGN_ON_SLUG;
}



// WEBPACK FOOTER //
// ./src/utils/admin-apps.js